import React from 'react';

import get from 'lodash/get';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import { Controller } from 'react-hook-form';

import { LabelTooltip } from '@src/components/ui/Tooltip';

const HookFormSelect = ({
    name,
    label,
    isRequired,
    control,
    errors,
    title,
    className,
    options = [],
    loading = false,
    loadingText = 'Loading...',
    defaultValue,
    onValueChange,
    disabled = false,
    placeholder,
}) => {
    const showLabel = label || title || isRequired;
    const isDisabled = disabled || loading;

    return (
        <Form.Group className={`mb-3 col w-100 floating-label ${className || ''}`} xs={12} sm={12} md={12} controlId={name}>
            {showLabel && (
                <Form.Label>
                    {isRequired && <abbr title="required">*</abbr>}
                    {' '}
                    {label}
                    {title && <LabelTooltip title={title} />}
                </Form.Label>
            )}
            <Controller
                render={({ field }) => (
                    <div className="select-chevron">
                        <Form.Control
                            {...field}
                            className="w-100"
                            as="select"
                            isInvalid={Boolean(errors[name])}
                            disabled={isDisabled}
                            value={field.value ?? ''}
                            onChange={(e) => {
                                field.onChange(e.target.value);
                                if (onValueChange) {
                                    onValueChange(e.target.value);
                                }
                            }}
                        >
                            {loading && (
                                <option value="">{loadingText}</option>
                            )}
                            {!loading && placeholder !== undefined && (
                                <option value="">{placeholder}</option>
                            )}
                            {!loading && options.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </Form.Control>
                    </div>
                )}
                control={control}
                name={name}
                defaultValue={defaultValue ?? ''}
            />
            {Boolean(get(errors, [name, 'message'])) && (
                <Form.Control.Feedback type="invalid" className="d-block">
                    {get(errors, [name, 'message'])}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};

HookFormSelect.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    isRequired: PropTypes.bool,
    control: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        label: PropTypes.string.isRequired,
    })),
    loading: PropTypes.bool,
    loadingText: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onValueChange: PropTypes.func,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
};

export default HookFormSelect;
